import localStorage from 'localStorage';

const PHONE = 'PHONE';

export default {
  set(phone) {
    localStorage.setItem(PHONE, phone);
  },
  remove() {
    localStorage.removeItem(PHONE);
  },
  get() {
    return localStorage.getItem(PHONE) ? localStorage.getItem(PHONE) : null;
  },
};
